import { NavBar } from '@/v2/components/NavBar';
import PageWithTOC, { Section } from '@/components/PageWithTOC';
import { PRODUCT_EMAIL, PRODUCT_NAME } from '@/shared/constance';


const termOfUseSections: Section[] = [
  {
    id: '',
    title: '',
    content: (
      <p className="text-base font-semibold text-content-primary">Thank you for using {PRODUCT_NAME}!</p>
    ),
  },
  {
    id: 'introduction',
    title: '1. ACCEPTANCE OF THESE TERMS OF SERVICE',
    content: (
      <div className="text-base font-normal text-content-primary">
        <p>
          1.1 These Terms of Service, including our{' '}
          <a className="underline" target="_blank" href="/policies/privacy-policy">
            Privacy Policy
          </a>{' '}
          , which is incorporated herein by reference (together, this “Agreement”), and is an
          important document that you should read ,is a legally binding contract between you and
          STREAMLAKE PTE. LTD. and its affiliates (collectively, “{PRODUCT_NAME}”,“company”, “us,”
          “we,” or “our”) regarding your use of the“{PRODUCT_NAME} and associated software
          applications and websites (all together, “Services”,” “{PRODUCT_NAME}”). References to
          “Customer,” “you”, and “your” refer to the individual accepting this Agreement, placing an
          Order, creating an Account, or otherwise using the Services.
        </p>
        <p>
          If the Services are being used on behalf of a company, organization, or other entity by an
          individual authorized to accept this Agreement on its behalf, then all references to
          “Customer,” “you,” or “your” shall refer to such entity and its Affiliates. If you are a
          company, organization, or other entity, the individual accepting this Agreement on your
          behalf represents and warrants that they have authority to bind you to this Agreement.
        </p>
        <p>
          1.2Our Service offers a suite of coding tools driven by machine learning to help
          developers write code more easily and efficiently and can provide suggested code, outputs
          or other functions.You may use our service to write code,software applications,scripts,and
          other code-based products.Subject to your compliance with these Terms, company grants you
          a limited right to access and use the Service. As a part of the Services, You may input,
          upload and submit information or other materials (&quot;Inputs&quot;，includes but is not
          limited to code, text, URLs, or other information, data, datasets, documentation,files and
          other materials ) to the Service and receive code, outputs, or other functions based on
          the Inputs provided by you (collectively, &quot;outputs&quot;) (Inputs and Outputs are
          collectively &quot;Content&quot;). We may use Content to provide the Service, comply with
          applicable law, enforce our terms and policies, and keep the Service safe. By submitting
          Inputs to the Service, you represent and warrant that you have all rights, licenses, and
          permissions that are necessary for us to process the Inputs under these Terms and to
          provide the Service to you.
        </p>
        <p>
          1.3 IF YOU USE {PRODUCT_NAME} AND RELATED SERVICES PROVIDED BY US (COLLECTIVELY, THE
          “SERVICES”), WHETHER IN WHOLE OR IN PART, YOU ARE DEEMED TO HEREBY REPRESENT AND WARRANT
          THAT YOU ARE LAWFULLY ABLE TO BE BOUND BY; AND AGREE TO BE BOUND BY AND ACCEPT, THESE
          TERMS AND OTHER RELATED DOCUMENTS THAT ARE EXPRESSLY INCORPORATED INTO THESE TERMS BY
          REFERENCE. If you are using our Services on behalf of a company, association, partnership,
          organization or other entity, whether in part or in whole, then you agree, represent,
          warrant and undertake that “you” and “your” includes you and the company, association,
          partnership, organization or other entity that you represent; you are duly authorized by,
          and will remain authorized by, such company, association, partnership, organization or
          other entity to agree on its behalf and bind such company, association, partnership,
          organization or other entity to these Terms; and the company, association, partnership,
          organization or other entity is legally responsible for your use of the Services as well
          as for the use of your Account by any other individual authorized by such company,
          association, partnership, organization or other entity, including without limitation any
          officers, directors, employees, agents and advisors of such company, association,
          partnership, organization or other entity.
        </p>
        <p className="font-semibold">
          1.4YOU MUST CAREFULLY READ AND FULLY UNDERSTAND THESE TERMS, INCLUDING ANY TERMS THAT MAY
          EXEMPT OR RESTRICT THE COMPANY’S LIABILITIES AND/OR RESPONSIBILITIES AND ANY TERMS THAT
          MAY RESTRICT AND/OR WAIVE YOUR RIGHTS , AS THEY APPLY TO YOUR USE OF THE SERVICES . IN
          PARTICULAR , THESE TERMS CONTAIN A DISPUTE RESOLUTION AND ARBITRATION PROVISION THAT
          AFFECTS YOUR RIGHTS UNDER THESE TERMS AND WITH RESPECT TO DISPUTES YOU MAY HAVE WITH THE
          COMPANY. YOUR USE OF THE SERVICES IS CONDITIONAL ON YOUR ACCEPTANCE OF THESE TERMS. IF YOU
          DO NOT AGREE WITH OR ACCEPT THESE TERMS, YOU SHALL NOT USE {PRODUCT_NAME} OR ANY OF THE
          OTHER SERVICES.
        </p>
        <p>
          <span className="font-semibold">1.5 Modifications：</span>In order to provide better
          services or for legal, regulatory or security reasons, we reserve the right to amend,
          replace and/or otherwise update these Terms from time to time. We will use commercially
          reasonable endeavors to notify you of any material changes to these Terms. The updated
          Terms shall become effective and replace the original Terms upon publication on the same
          day of the updated Terms are published on the Website, unless otherwise indicated in the
          Terms. You shall review these Terms regularly to check for such changes or agree to our
          updated Terms via clicking notices on the Website, push messages or emails. If you do not
          agree with or accept the updated Terms, you should choose not to use {PRODUCT_NAME} or any
          of the related Services. You will be deemed to have read, understood and accepted the
          updated Terms if you continue to use {PRODUCT_NAME} or any of the related Services.
        </p>
        <p className="font-semibold">
          ARBITRATION NOTICE. You agree that disputes arising under this Agreement will be resolved
          by binding, individual arbitration as specified below , and BY ACCEPTING THESE TERMS, YOU
          AND {PRODUCT_NAME} ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE IN ANY
          CLASS ACTION OR REPRESENTATIVE PROCEEDING.
        </p>
      </div>
    ),
  },
  {
    id: 'registration-and-use',
    title: '2. REGISTRATION AND USE',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <div>
          <p className="font-semibold">2.1 Your Eligibility</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              You must be at least 18 years old or the age of majority in your
              jurisdiction,whichever is higher.By using the Services, you confirm that you are over
              the relevant age specified herein,and your registration and use of the Service is in
              compliance with all applicable laws in your region.If we learn that someone under the
              relevant age specified above is using the Services, we will terminate that account.
            </li>
            <li>
              Anyone under the age of 13 or other minimum age as defined under applicable laws of
              your jurisdiction (“Minimum Age”) shall not use the Services.If you have reached the
              Minimum Age but are under the age of majority as defined under applicable laws of your
              jurisdiction (“Majority Age”), you may only use and register for a {PRODUCT_NAME}
              account on the Website (“Account”) through the representation of your parent or legal
              guardian, and your parent or legal guardian hereby represents you and accepts these
              Terms.
            </li>
            <li>
              Where parental consent or authorization is required under such applicable laws and
              regulations, you have the obligation to provide to us evidence of such consent or
              authorization, including as required under applicable laws and regulations, the
              consent or authorization of the holder of parental responsibility for the minor. We
              may refuse to process or continue to process the minor’s personal information, or
              provide or continue to provide the Services to the minor until we receive this
              evidence of consent or authorization.
            </li>
            <li>
              If you are a minor in your country or region, your use of the Services may be subject
              to further age restrictions, whether imposed by us or any third party vendor in
              connection with the provision of certain Services. You may be unable to use or only
              have limited access to those Services, such as participating in rewards programs,
              top-up without the assistance of your parent or legal guardian.
            </li>
            <li>
              If you learn that a child below the Minimum Age has registered for a {PRODUCT_NAME}
              Account or an Account of a child below the Majority Age was not registered under
              proper representation or guardianship, you may alert us at {PRODUCT_EMAIL}. We will
              promptly verify, take steps to remove such child’s Account information from
              {PRODUCT_NAME} and terminate the child’s Account.
            </li>
          </ol>
        </div>

        <div>
          <p className="font-semibold">2.2 License</p>
          <p>
            Subject to your compliance with these Terms, we hereby grant you a non-exclusive,
            non-sublicensable, non-transferable, personal, limited license to use {PRODUCT_NAME}{' '}
            only on your personal smartphone, tablet, computer or other mobile or wireless device
            (which must be designated by us as being compatible for use with {PRODUCT_NAME}).
            Company reserves all rights not expressly granted to you herein. You acknowledge and
            agree that we may terminate this license at any time, for any reason, with or without
            cause.
          </p>
        </div>

        <div>
          <p className="font-semibold">2.3 Access to {PRODUCT_NAME}</p>
          <p>
            The Services are offered and provided to you on an &quot;as is&quot; and &quot;as
            available&quot; basis at your sole risk. Our goal is to minimize disruption caused by
            technical errors; however, we cannot guarantee the continuous, uninterrupted or
            error-free operability of {PRODUCT_NAME}
            at all times. There may be times when certain functionality or features of{' '}
            {PRODUCT_NAME} or content made available through {PRODUCT_NAME}, or the entire{' '}
            {PRODUCT_NAME}, become unavailable (whether on a scheduled or unscheduled basis) or are
            modified, suspended or withdrawn by us, at our sole discretion, without notice to you.
            You agree that we will not be liable to you or to any third party for any
            unavailability, modification, suspension or withdrawal of {PRODUCT_NAME}, or any
            feature, part or content of {PRODUCT_NAME}. We are not responsible if you cannot access
            the Services properly or at all because of any event out of our control, for example
            (without limitation) the performance of any software or operating system running on your
            device or any connected software, hardware, network or service.
          </p>
        </div>

        <div>
          <p className="font-semibold">2.4 Account Registration</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              To use certain of the Services, you must register for an account.When you register for
              an account, you may be required to provide us with information about yourself, such as
              your name, your user name,email address, or other contact information. You can also
              create an account or link another account, such as your GitHub account、Google account
              (“Account”).
            </li>
            <li>
              You shall provide us with the information and complete all the registration procedures
              according to the instructions on the registration page. By creating an Account:
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li>
                  you undertake to and shall provide true, accurate, up to date, and complete
                  information as we may from time to time request, and shall not provide us with any
                  false or misleading information;
                </li>
                <li>
                  you authorize us to assume that any person using {PRODUCT_NAME} with your user
                  name and password is either you or a person authorized to act for you;
                </li>
                <li>you must not impersonate or attempt to impersonate another person; and</li>
                <li>
                  you must safeguard the user name and password of your Account and keep them secret
                  and confidential.
                </li>
              </ol>
            </li>
          </ol>
        </div>

        <div>
          <p className="font-semibold">2.5 Account Safety and Management</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              You undertake to, and shall, comply with all applicable laws and regulations when you
              use {PRODUCT_NAME} and any of the related Services.
            </li>
            <li>
              If you authorize any person to act for you in relation to the use of {PRODUCT_NAME},
              you will ensure that they comply with these Terms at all times. You are responsible
              for ensuring that your Account is secure. You are advised to take care of your Account
              and ensure to log out appropriately. You must secure the user name and password
              associated with your Account and regularly change it.
            </li>
            <li>
              Your Account can only be used by yourself and you may not lend, give away or rent the
              Account or transfer, sell or share the Account in breach of these Terms. Otherwise,you
              will be responsible for any legal consequences arising therefrom.
            </li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: 'instructions-of-conduct',
    title: '3. INSTRUCTIONS OF CONDUCT',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <div>
          <p>
            3.1 Your access to and use of the Services is subject to these Terms and all applicable
            laws and regulations. You may not:
          </p>
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-4">
            <li>
              access or use the Services if you are not fully able and legally competent to agree to
              these Terms or are authorized to use the Services by your parent or legal guardian;
            </li>
            <li>
              make unauthorised copies, modify, adapt, translate, delete, alter,reverse engineer,
              disassemble, decompile or create any derivative works of the Services or any content
              included therein, including any files, tables or documentation (or any portion
              thereof) or determine or attempt to determine any source code, algorithms, methods or
              techniques embodied by the Services or any derivative works thereof;
            </li>
            <li>
              distribute, license, transfer, or sell, in whole or in part, any of the Services or
              any derivative works thereof;
            </li>
            <li>
              market, rent or lease the Services for a fee or charge, or use the Services to
              advertise or perform any commercial solicitation without our written consent ;
            </li>
            <li>
              use the Services, without our written consent, for any commercial or unauthorized
              purpose, including communicating or facilitating any commercial advertisement or
              solicitation or spamming;
            </li>
            <li>
              interfere with or attempt to interfere with the proper working of the Services,
              disrupt the Website or any networks connected to the Services, or bypass any measures
              we may use to prevent or restrict access to the Services;
            </li>
            <li>
              incorporate the Services or any portion thereof into any other program or product. In
              such case, we reserve the right to refuse service, terminate accounts or limit access
              to the Services in our sole discretion;
            </li>
            <li>
              use automated scripts to collect information from or otherwise interact with the
              Services;
            </li>
            <li>
              impersonate any person or entity, or falsely state or otherwise misrepresent you or
              your affiliation with any person or entity, including giving the impression that any
              content you upload, post, transmit, distribute or otherwise make available emanates
              from the Services;
            </li>
            <li>
              intimidate or harass another, or promote sexually explicit material, violence or
              discrimination based on race, sex, religion, nationality, disability, sexual
              orientation or age;
            </li>
            <li>
              use or attempt to use another’s account, service or system without authorisation from
              us, or create a false identity on the Services;
            </li>
            <li>
              use the Services in a manner that may create a conflict of interest or undermine the
              purposes of the Services, such as trading reviews with other users or writing or
              soliciting fake reviews;
            </li>
            <li>
              use the Services to upload, transmit, distribute, store or otherwise make available in
              any way: files that contain viruses, trojans, worms, logic bombs or other material
              that is malicious or technologically harmful;
            </li>
            <li>
              any unsolicited or unauthorised advertising, solicitations, promotional materials,
              “junk mail,” “spam,” “chain letters,” “pyramid schemes,” or any other prohibited form
              of solicitation;
            </li>
            <li>
              solicit, or attempt to solicit any private information of any third party, including
              addresses, phone numbers, email addresses, number and feature in the personal identity
              document (e.g.,national identification numbers, passport numbers) or credit card
              numbers;
            </li>
            <li>
              any material which does or may infringe any copyright, trademark or other intellectual
              property or privacy rights of any other person;
            </li>
            <li>
              any material which is defamatory of any person, obscene, offensive, pornographic,
              hateful or inflammatory;
            </li>
            <li>
              any material that would constitute, encourage or provide instructions for a criminal
              offence, dangerous activities or self-harm;
            </li>
            <li>
              any material that is deliberately designed to provoke or antagonise people, especially
              trolling and bullying, or is intended to harass, harm, hurt, scare, distress,
              embarrass or upset people;
            </li>
            <li>
              any material that contains a threat of any kind, including threats of physical
              violence;
            </li>
            <li>
              any material that is racist or discriminatory, including discrimination on the basis
              of someone’s race, religion, age, gender, disability or sexuality;
            </li>
            <li>
              material that, in our sole judgment of us, is objectionable or which restricts or
              inhibits any other person from using the Services, or which may expose {PRODUCT_NAME},
              the Services or any of our other users to any harm or liability of any type.
            </li>
            <li>
              use the Services or any content, data, information, or other materials made available
              through the Services (including Output) for purposes of, directly or indirectly,
              creating, testing, improving, training, or otherwise developing your or any third
              party’s artificial intelligence or machine learning models, systems, architecture,
              weights or related technology.
            </li>
          </ol>
        </div>

        <p>
          All rights granted to you under these Terms might be terminated in the event that you are
          found to be in breach of any of the above at our sole discretion.
        </p>

        <div>
          <p>
            3.2 Artificial intelligence and machine learning are rapidly evolving fields of study.
            We are constantly working to improve our Services to make them more accurate, reliable,
            safe, and beneficial. Given the probabilistic nature of machine learning, use of our
            Services may, in some situations, result in Output that does not accurately reflect real
            people, places, or facts.{' '}
          </p>
          <p>When you use our Services you understand and agree that:</p>
          <ol className="list-[lower-roman] space-y-2 pl-4">
            <li>
              The Output may not always be accurate. You should not rely on Output generated
              generated from the use of our Services as a sole source of truth or factual
              information, or as a substitute for professional advice.
            </li>
            <li>
              You bear the responsibility to assess the accuracy and suitability of the output for
              your specific needs. This includes: conducting a human review, where necessary, prior
              to the application or dissemination of the output from our Services; and making your
              own determination regarding the intellectual property rights you have in output,
              taking into account, among other things, your usage scenario(s) and the laws of the
              relevant jurisdiction. NOTWITHSTANDING THE FOREGOING, YOU MUST NOT USE THE OUTPUT FOR
              ANY UNLAWFUL OR INFRINGING PURPOSES.
            </li>
            <li>
              You must not use any Output relating to a individual for any purposes that could have
              a legal or material impact on that person, such as making credit, educational,
              employment, housing, insurance, legal, medical, or other important decisions about
              them.
            </li>
            <li>
              Our Services may provide incomplete, incorrect, or offensive Output that does not
              represent our views. If the Output references any third party products or services, it
              does not mean the third party endorses or is affiliated with us.
            </li>
          </ol>
          <p>
            We make no representations, warranties, guarantees or conditions that any output is free
            from errors or bugs, authentic, accurate, verifiable, reliable, complete or up-to-date
            and disclaim any and all representations, warranties, guarantees and conditions of any
            nature for the output, expressly or implied. Output generated for you is not unique; the
            Services may generate the same or similar output for different users.
          </p>
        </div>

        <p>
          3.3 We cannot and do not guarantee that any Content（defined below） will be free from
          viruses and/or other code that may have contaminating or destructive elements. It is your
          responsibility to implement appropriate information technology security safeguards
          (including anti-virus and other security checks) to satisfy your particular requirements
          as to the safety and reliability of {PRODUCT_NAME} and the Content made available through
          them.
        </p>

        <p>
          3.4 If your use of {PRODUCT_NAME} results in the need for servicing or replacing property,
          material, equipment or data, we will not be responsible for such costs.
        </p>

        <p>
          3.5 You are responsible for the Content uploaded or published by you for compliance with
          applicable laws and regulations, requirements of competent governmental authorities and
          our internal policies. In addition to complying with the content removal orders from any
          relevant judicial or administrative authorities or requests of the Users or any third
          parties, in response to complaints from other Users or any third parties, or if we, in our
          sole discretion, believe that any Content does not comply with these Terms, we may take
          any measures, including without limitation removing or refusing to display such Content.
        </p>

        <p>
          3.6You acknowledge and agree that Content you uploaded or published will be considered
          non-proprietary and non-confidential. You must not upload or transit any content that you
          consider to be proprietary or confidential. You may decide and control the extent of the
          availability of your content (i.e. whether to all other Users, Users you selected or only
          to yourself) by way of {PRODUCT_NAME}’s settings, subject to features and functions
          available in {PRODUCT_NAME}.
        </p>
        <p>
          3.7The Service may include a feature that automatically executes code Suggestions without
          manual review or confirmation, and will be clearly labeled accordingly. By enabling this
          feature, you acknowledge and agree that you are assuming all risks associated with the
          execution of automatically generated code, including without limitation system outages,
          software defects, data loss, and security vulnerabilities. YOU ARE SOLELY RESPONSIBLE FOR
          ANY IMPACT RESULTING FROM USE OF THIS FEATURE, INCLUDING ENSURING APPROPRIATE SAFEGUARDS,
          TESTING, AND MONITORING ARE IN PLACE.
        </p>
      </div>
    ),
  },
  {
    id: 'intellectual-property',
    title: '4. INTELLECTUAL PROPERTY RIGHTS AND CONTENT',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          4.1 We respect intellectual property rights and encourage you to upload or transit
          original content, and we will take measures to protect your intellectual property rights
          in accordance with applicable laws and regulations.
        </p>

        <p>
          4.2In connection with your use of the Services, you may be able to post, upload, or submit
          content to be made available through the Services (collectively with Input, “Your
          Content”). As between the Company and you, the Company does not claim any ownership in
          Your Content; provided that, the Company or its affiliates and their respective licensors
          own and will continue to own the Services and any and all other software or technology
          that was used to generate any Output.
        </p>

        <p>
          4.3 You warrant and undertake that you hold the intellectual property rights to the Input
          or that you have obtained legal authorization from the relevant owner to the use of the
          Input and that your use of the Input shall not violate any applicable laws and regulations
          or infringe upon the legitimate rights and interests of any third parties (including,
          without limitation, copyright, patent, trademark and other intellectual property rights
          and personality rights, personal data rights and other rights and interests).You may not
        </p>
        <ol className="list-[lower-roman] space-y-2 pl-4">
          <li>
            publish any Output generated by the Services without clearly citing the Services, or
          </li>
          <li>
            misrepresent the source of any Output or the fact that it was generated by artificial
            intelligence.
          </li>
        </ol>
        <p>
          We reserve the right to moderate, block, or delete the Input (or part thereof) upon
          notification from an intellectual property rights owner or any other persons of any
          suspected or actual intellectual property rights infringement, and you shall be liable for
          any and all loss, damages or other consequences incurred by us or our affiliates arising
          out of, in connection with and/or relating to such suspected or actual infringement.
        </p>

        <p>
          4.4 To the extent permitted by the applicable laws, the intellectual property and other
          property interests (if any) of the Output generated in the process of the Service shall be
          vested in the owner thereof as provided for in the applicable laws.
        </p>

        <p>
          4.5 You acknowledge and agree that if you have intellectual property rights, portrait
          rights or other legitimate rights or interests on the Input and/or Output in accordance
          with applicable law, your use of the Services will not constitute a transfer of such
          legitimate rights or interests, unless agreed otherwise by you and us.Specifically,
          without our written permission, you may not use, reproduce, distribute, and create
          derivative works of, and make modifications to, the Output for any commercial purposes.
        </p>

        <div>
          <p className="font-semibold">4.6 License</p>
          <p>
            4.6.1 Subject to legitimate commercial purposes in accordance with the applicable law,
            {PRODUCT_NAME} has an non-exclusive, royalty-free right and license during the
            operational period of its business and within the territories in which {PRODUCT_NAME}{' '}
            conducts business to use the Content of which that you own the right to use in
            accordance with the applicable laws ,which shall comprise the Input you provide or
            upload to the Service and Output generated during the use of our Service, including such
            right to host, store, transfer, publicly display, publicly perform (including by means
            of a digital audio transmission), communicate to the public, reproduce, modify for the
            purpose of formatting for display, create derivative works from , and to distribute
            Input and Output, in whole or in part, in any media formats and through any media
            channels.
          </p>

          <p>
            4.6.2We may, at our discretion or by licensing to third parties, use or develop the
            aforementioned Content (in whole or in part) for the purposes of promotion,
            product/function upgrades, and to research on new products/functions. You undertake not
            to claim personal rights or property rights in connection with our use or development of
            the Content.
          </p>

          <p>
            4.6.3 Without limiting the generality of the foregoing license, {PRODUCT_NAME} may
            process usage data, aggregated data, or Input for its lawful business purposes, We may
            also use Your Content to provide and improve the Services, in accordance with applicable
            laws including but not limited to the following :
          </p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li> track use of the Services for billing purposes;</li>
            <li>
              provide support for the Services,such as using AI to generate code, outputs, or other
              functions based on your input;
            </li>
            <li>
              Building codebase indexes by temporarily uploading code from your codebase (&quot;Your
              Codebase&quot;) to our servers to compute embeddings. Once processing is completed,
              the generated embeddings and associated metadata and codebase files are retained and
              be stored, if you don&apos;t want us to store,you can choose delete codebase indexes
              ,once you choose delete,we will delete Your Codebase and the generated embeddings and
              associated metadata in our servers;
            </li>
            <li> monitor the performance and stability of the Services;</li>
            <li> prevent or address technical issues with the Services;</li>
            <li>
              improve the Services, its other products and services, and to develop new products and
              services;
            </li>
            <li>
              create, test, improve, or otherwise develop the Services, systems, architecture,
              weights or related technology used by {PRODUCT_NAME} in connection with the Services;
              and
            </li>
            <li>
              for all other lawful business practices, such as analytics, benchmarking, and reports.
            </li>
          </ol>

          <p>
            4.6.4 If you do not wish us to continue using all or part of the licensed content, you
            may notify us to revoke the authorization by sending an email to{' '}
            <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>.
          </p>
        </div>

        <p>
          4.7Notwithstanding the foregoing, the whole or part of User Content provided by one User
          may be extracted by another User to produce additional User Content, subject to prior
          approval from the User, where applicable. When you choose to transfer or upload User
          Content, which may include content generated by other Users and/or us, to other platforms
          or websites operated by a third party, you shall do so in compliance with these Terms and
          any terms and conditions of use of such other platform or website.
        </p>

        <p>
          4.8You acknowledge that {PRODUCT_NAME} and the content provided through {PRODUCT_NAME} are
          subject to protection by trademark, copyright and other intellectual property rights. You
          may not use content from our Services unless you obtain permission from its owner or are
          otherwise permitted by applicable laws. Do not remove, obscure, or alter any legal notices
          displayed in or along with our Services. Further, you shall not sell, reproduce,
          distribute, modify, display, publicly perform, prepare derivative works based on, repost
          or otherwise use any content owned by us in any way for any public or commercial purpose
          without our prior written consent. Without prejudice to other remedies that we are
          entitled to, we reserve the right, with or without notice, at any time and in our sole
          discretion to suspend and/or terminate the Accounts of any User who infringes or is
          alleged to infringe any trademarks, copyrights or other intellectual property rights.
        </p>
      </div>
    ),
  },
  {
    id: 'copyright-complaints',
    title: '5. Copyright Complaints',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          The code generation capabilities of the Services are designed to generate new, original
          code. Attempting to generate existing, copyrighted code via specific requests or other
          prompt manipulation is a violation of these Terms. If you encounter an inappropriate
          response or output from the Services that violates applicable laws, or if you believe that
          your intellectual property rights have been infringed，please send notice to the address
          below. We may delete or disable content that we believe violates these Terms or is alleged
          to be infringing and will terminate accounts of repeat infringers where appropriate.
        </p>
        <p>
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>
        </p>
        <p>
          Written claims concerning copyright infringement must include the following information:
        </p>
        <ul className="list-disc space-y-2 pl-6">
          <li>
            A physical or electronic signature of the person authorized to act on behalf of the
            owner of the copyright interest
          </li>
          <li>A description of the copyrighted work that you claim has been infringed upon</li>
          <li>
            A description of where the allegedly infringing material is located on our Website so we
            can find it
          </li>
          <li>Your address, telephone number, and e-mail address</li>
          <li>
            A statement by you that you have a good-faith belief that the disputed use is not
            authorized by the copyright owner, its agent, or the law
          </li>
          <li>
            A statement by you that the above information in your notice is accurate and, under
            penalty of perjury, that you are the copyright owner or authorized to act on the
            copyright owner’s behalf.
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 'commercial-terms',
    title: '6. Commercial Terms',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          6.1 The Services we provide to you could be free or paid services. Specific details shall
          be subject to the information displayed on {PRODUCT_NAME}.
        </p>
        <p>
          6.2 You understand and agree that we may adjust the standards and methods by which we
          charge fees for the Services based on the needs of business development, and may also
          start charging for some previously free services. We will notify or announce such changes
          through {PRODUCT_NAME}. For clarity, the provision of free services through {PRODUCT_NAME}{' '}
          shall not be construed as a waiver of our right to charge fees in the future.
        </p>
        <p>
          6.3 You understand and agree that {PRODUCT_NAME} may contain other service content
          provided by our affiliated companies or third parties. We merely provide subscription
          and/or access points for these services on the {PRODUCT_NAME} for your convenience. If you
          wish to use such services, you should separately enter into an agreement with the
          corresponding service provider, pay the corresponding fees (if any), and bears all
          potential risks. We do not provide any form of guarantee or warranty for the services
          provided by our affiliated companies or other third parties.
        </p>
      </div>
    ),
  },
  {
    id: 'exclusion-warranties',
    title: '7. EXCLUSION OF WARRANTIES; INDEMNIFICATION; AND LIABILITIES',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <div>
          <p className="font-semibold">7.1 EXCLUSION OF WARRANTIES</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              Your use of the Services is entirely at your own risk.By using the Services, you
              confirm that you have carefully considered these Terms and fully understand its
              implications on your legal rights.
            </li>
            <li>
              THE SERVICES ARE PROVIDED “AS IS” AND WE MAKE NO WARRANTY OR REPRESENTATION TO YOU
              WITH RESPECT TO THE SERVICES . IN PARTICULAR, WE DO NOT REPRESENT OR WARRANT TO YOU
              THAT：
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li> YOUR USE OF THE SERVICES WILL MEET YOUR REQUIREMENTS;</li>
                <li>
                  YOUR USE OF THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE OR FREE FROM ERROR;
                </li>
                <li>
                  ANY INFORMATION OBTAINED BY YOU AS A RESULT OF YOUR USE OF THE SERVICES WILL BE
                  ACCURATE OR RELIABLE; OR
                </li>
                <li>
                  DEFECTS IN THE OPERATION OR FUNCTIONALITY OF ANY SOFTWARE PROVIDED TO YOU AS PART
                  OF THE SERVICES WILL BE CORRECTED.
                </li>
              </ol>
              TO THE FULLEST EXTENT PROVIDED BY LAW, WE HEREBY DISCLAIM ALL WARRANTIES OF ANY KIND,
              WHETHER EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY
              WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
              THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR LIMITED UNDER
              APPLICABLE LAW.
            </li>
          </ol>
        </div>

        <div>
          <p className="font-semibold">7.2 INDEMNIFICATION; LIMITATIONS ON LIABILITY</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              NOTHING IN THESE TERMS SHALL EXCLUDE OR LIMIT OUR LIABILITY FOR LOSSES WHICH MAY NOT
              BE LAWFULLY EXCLUDED OR LIMITED BY APPLICABLE LAW.
            </li>
            <li>
              You agree to defend, indemnify, and hold harmless us, our parent companies,
              subsidiaries, and affiliates and each of our respective officers, directors,
              employees, agents and advisors from any and all claims, liabilities, costs, and
              expenses, including, but not limited to, attorneys&apos; fees and expenses on an
              indemnity basis , arising out of a breach by you, your content or any user of your
              Account of applicable laws and regulations or these Terms, including your obligations,
              representation and warranties herein.
            </li>
            <li>
              To the extent that such liabilities may be unlimited or excluded under applicable laws
              and regulations, we are not liable to you for and you agree to defend, indemnify, and
              hold harmless us, our parent companies, subsidiaries, and affiliates, and each of our
              respective officers, directors, employees, agents and advisors from any and all
              claims, liabilities, costs, and expenses, including, but not limited to,
              attorneys&apos; fees and expenses on an indemnity basis, in respect of your use of the
              Services and/or
              {PRODUCT_NAME}, or access to any information as a result of such use by you or any
              other person, whether or not authorized.
            </li>
            <li>
              YOU AGREE THAT {PRODUCT_NAME} HAS NO LIABILITY FOR ANY LOSS OR DAMAGES (WHETHER DIRECT
              OR INDIRECT) SUFFERED BY YOU DUE TO:
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li>
                  ANY INTERRUPTION, INTERCEPTION, SUSPENSION, DELAY, LOSS, UNAVAILABILITY, OR OTHER
                  FAILURE IN PROVIDING THE SERVICES OR YOUR USE OF {PRODUCT_NAME}, IN TRANSMITTING
                  INSTRUCTIONS OR INFORMATION RELATING TO THE SERVICES OR YOUR USE OF {PRODUCT_NAME}
                  , OR IN CONNECTING WITH THE SERVICES OR YOUR USE OF {PRODUCT_NAME} CAUSED BY ANY
                  ACTS, OMISSIONS OR CIRCUMSTANCES BEYOND OUR REASONABLE CONTROL, INCLUDING WITHOUT
                  LIMITATION MAINTENANCE OR CONNECTION FAILURE OF THE INFORMATION NETWORK EQUIPMENT,
                  FAILURE OF COMPUTER, COMMUNICATION OR OTHER SYSTEMS, HACKER ACTIVITIES, COMPUTER
                  VIRUSES, POWER FAILURE, STRIKE, REVOLT, FIRE, FLOOD, STORM, EXPLOSION, WAR,
                  PANDEMIC, ACT OF GOVERNMENT, ORDER OF JUDICIAL AND ADMINISTRATIVE AUTHORITIES OR
                  ANY OTHER THIRD-PARTY REASONS; OR
                </li>
                <li>
                  TRANSMISSION AND/OR STORAGE OF INFORMATION AND/OR DATA RELATING TO YOU, THE
                  SERVICES, {PRODUCT_NAME} AND/OR TRANSACTIONS OR DEALINGS CONDUCTED BY YOU PURSUANT
                  TO THE SERVICES THROUGH OR IN ANY SYSTEM, EQUIPMENT OR INSTRUMENT OF COMMUNICATION
                  NETWORK PROVIDER.
                </li>
              </ol>
            </li>
            <li>
              If you violate or are suspected of violating applicable laws and regulations or these
              Terms, we reserve the right to take all necessary actions (including but not limited
              to suspending or terminating your Account or your use of the Services, or reporting to
              the relevant authorities) immediately without notice to you at our sole discretion.
            </li>
            <li>
              SUBJECT TO APPLICABLE LAWS AND REGULATIONS, WE ARE NOT AND SHALL NOT BE RESPONSIBLE
              FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL OR INDIRECT DAMAGES, LOSS OR CORRUPTION OF
              DATA, LOSS OF PROFITS, LOSS OF REVENUE, GOODWILL, OPPORTUNITY OR LOSS OF ANTICIPATED
              SAVINGS OR ANY OTHER LOSS OR DAMAGES OF ANY KIND RESULTING FROM YOUR ACCESS TO,
              RELIANCE ON, OR USE OF, OR INABILITY TO USE THE SERVICES, WHETHER OR NOT WE HAVE BEEN
              ADVISED OF THE POSSIBILITY THEREOF.
            </li>
            <li>
              To the fullest extent permitted by applicable laws and regulations, you acknowledge
              and agree that any claim or dispute you have with any other third party in connection
              with the Services ,including, by way of example and not limitation, any carrier,
              copyright owner or other User,is between you and such third party and you irrevocably
              agree to release, indemnify and hold harmless us, our parent companies, subsidiaries,
              and affiliates, and each of our respective officers, directors, employees, agents and
              advisors from any and all claims, demands and/or damages (actual and consequential) of
              every kind and nature, known and unknown, arising out of or in any way connected with
              such such claim or dispute.
            </li>
            <li>
              OUR TOTAL LIABILITY TO YOU, WHETHER BASED ON AN ACTION OR CLAIM IN CONTRACT, TORT
              (INCLUDING NEGLIGENCE), BREACH OF STATUTORY DUTY OR OTHERWISE ARISING OUT OF, OR IN
              RELATION TO, THESE TERMS, IF ANY, SHALL BE LIMITED TO THE TOTAL AMOUNT OF PAYMENTS
              MADE BY YOU TO US IN THE PAST 6 MONTHS.THE LIMITATION IN THIS SECTION APPLY ONLY TO
              THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAWS.
            </li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: 'personal-information',
    title: '8. YOUR PERSONAL INFORMATION',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          We collect and process personal data of users of {PRODUCT_NAME}. All personal data is
          handled in accordance with our Privacy Policy , which is expressly incorporated into these
          Terms by reference.
        </p>
        <p>
          Specifically, you acknowledge and agree that we are not responsible for the Touch ID,
          fingerprint authentication or similar sensor or biometric technology (where available) on
          the device you access and/or use {PRODUCT_NAME} with and we expressly exclude any
          statutory or other warranty, condition, term or undertaking as to the quality, accuracy or
          performance of such Touch ID, fingerprint authentication or similar sensor or biometric
          technology as a means for securing access to and using {PRODUCT_NAME} and/or the Services.
        </p>
      </div>
    ),
  },
  {
    id: 'third-party-providers',
    title: '9. THIRD PARTY PROVIDERS',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          9.1 You acknowledge that certain parts of {PRODUCT_NAME} and certain content and services
          made available through {PRODUCT_NAME} (other than the User Content) are provided or
          maintained by third parties(including without LLM , Plugins, and APIs ) and not by us. By
          using the Service, you acknowledge and agree that we are not responsible for examining or
          evaluating the content, accuracy, completeness, availability, timeliness, validity,
          copyright compliance, legality, decency, quality or any other aspect of any such third
          party content or services.
        </p>
        <p>
          9.2 We do not guarantee the quality, reliability or suitability of the content or services
          provided by any third parties, made available, advertised or linked through {PRODUCT_NAME}
          , and we will bear no responsibility for your access to, use of, interaction or
          relationship with the content or services provided by any third parties. You agree that
          you access, view and interact with all such services and content at your own risk. If you
          access third party services through {PRODUCT_NAME}, you must comply with any terms and
          conditions (such as user terms, acceptable use policies, privacy policies, and content
          policies) applicable to those services.You acknowledge and agree that your use of the
          third party LLMs, Plugins, and APIs may be subject to conditions established by such third
          parties (such as a third party LLM may refuse to generate output for you if your input is
          harmful or contains improper content).
        </p>
        <p>
          9.3 You agree that, we will not be liable or responsible for any loss or damage of any
          sort incurred as the result of any correspondence or dealing solely between you any third
          party.
        </p>
        <p>
          9.4 Subject to our Privacy Policy, we may explore and integrate developer tools provided
          by third parties from time to time to enable or facilitate features, functions or business
          for {PRODUCT_NAME} platform in accordance with this Agreement.
        </p>
      </div>
    ),
  },
  {
    id: 'external-links',
    title: '10. EXTERNAL LINKS',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          To the extent where {PRODUCT_NAME} contains any link to other websites or resources, the
          following provisions apply:
        </p>
        <ol className="list-[lower-alpha] space-y-2 pl-4">
          <li>
            Although these websites or resources are selected with care, we are not responsible for
            the content or accuracy of any off-site pages or any other sites or resources linked to{' '}
            {PRODUCT_NAME} (including those sites or resources linked through advertisements or
            through any search engines).
          </li>
          <li>
            We are also not responsible for the processing of your personal data by these websites
            or resources. You may need to refer to their privacy policies with regard to such
            processing.
          </li>
          <li>
            The fact that we include links to such external websites and resources does not imply
            any endorsement of, or association with such operators, content or opinions. Your use of
            websites or resources linked from {PRODUCT_NAME} is subject to any terms and conditions
            applicable to those websites or resources.
          </li>
        </ol>
      </div>
    ),
  },
  {
    id: 'governing-laws',
    title: '11. GOVERNING LAWS',
    content: (
      <div className="text-base font-normal text-content-primary">
        <p>
          To the fullest extent permitted by applicable laws and regulations, the validity,
          interpretation, modification, supplement, termination, execution of these Terms and any
          dispute or claim resulting from or in connection with these Terms will be governed by and
          construed in accordance with the laws of Singapore, provided that nothing shall prevent us
          from bringing proceedings to protect our intellectual property rights before any competent
          court in any other jurisdiction.
        </p>
      </div>
    ),
  },
  {
    id: 'dispute-resolution',
    title: '12. DISPUTE RESOLUTION',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          12.1 Any dispute, controversy or claim (whether in contract, tort or otherwise arising out
          of, relating to, or in connection with these Terms, including their existence, validity,
          interpretation, performance, breach or termination shall be firstly settled through
          friendly and amicable negotiation between you and us. If the negotiation fails, it will be
          referred to and finally resolved by arbitration administered by the Singapore
          International Arbitration Centre (&quot;SIAC&quot;) in accordance with the arbitration
          rules of the SIAC then in force when the Notice of Arbitration is submitted by a party .
          The seat of the arbitration will be Singapore.The arbitration proceedings will be
          conducted in English.
        </p>

        <p>
          12.2 The arbitration will be conducted by videoconference if possible, but if the
          arbitrator determines a hearing should be conducted in person, the venue of the hearing
          will be mutually agreed upon, failing which the venue of the hearing shall be determined
          by the sole arbitrator. You and the Company agree that any settlement amount offered by
          any party will not be disclosed to the arbitrator by either party until after the
          arbitrator determines the final award, if any.
        </p>

        <p>
          12.3 You and the Company agree that disputes must be brought on an individual basis only,
          and may not be brought as a plaintiff or class member in any purported class,
          consolidated, or representative proceeding. Class arbitrations, class actions, and
          representative actions are prohibited. Only individual relief is available. The parties
          agree to sever and litigate in court any request for public injunctive relief after
          completing arbitration for the underlying claim and all other claims. The foregoing does
          not prevent either party from participating in a class-wide settlement. You and the
          Company knowingly and irrevocably waive any right to trial by jury in any action,
          proceeding, or counterclaim.
        </p>

        <p>
          12.4 If any part of terms of this Section 12 is found to be illegal or unenforceable, the
          remainder will remain in effect, except that if a finding of partial illegality or
          unenforceability would allow class arbitration, class action, or representative action,
          this entire dispute resolution section will be unenforceable in its entirety.
        </p>
      </div>
    ),
  },
  {
    id: 'term-and-termination',
    title: '13. Term and Termination',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          13.1 Term. This Agreement starts on the Effective Date and continues until the earlier of
          (a) expiration or termination of all Terms, or (b) termination of this Agreement pursuant
          to Section 13.2.
        </p>

        <div>
          <p className="font-semibold">13.2 Termination</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              You are free to stop using our Services at any time.You may terminate your Account and
              this Agreement at any time through your account settings or by contacting
              {PRODUCT_NAME} at <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>.
            </li>
            <li>
              If You violate any provision of this Agreement, then your authorization to access the
              Services and this Agreement shall automatically terminate with immediate effect . In
              addition, {PRODUCT_NAME} may, in its sole discretion, terminate this Agreement or your
              Account, or suspend or terminate your access to the Services, at any time for any
              reason or no reason, with or without notice, and without any liability to you arising
              from such termination.
            </li>
            <li>
              We may decide to discontinue our Services, but if we do, we will give you advance
              notice and a refund for any prepaid, unused Services.
            </li>
          </ol>
        </div>

        <p>
          13.3 If you believe we have suspended or terminated your account in error, you can file an
          appeal with us by contacting our support team at{' '}
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>.
        </p>
      </div>
    ),
  },
  {
    id: 'miscellaneous',
    title: '14. MISCELLANEOUS',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          14.1 These Terms are the entire agreement between you and us in relation to your use of
          the Services and supersede all prior agreements between us in relation to your use of the
          Services.
        </p>

        <p>
          14.2 The failure by either party to exercise or enforce any right or remedy of these Terms
          will not constitute a waiver of such right or remedy, nor shall it prevent or restrict the
          further exercise of that or any other right or remedy. No single or partial exercise of
          such right or remedy shall prevent or restrict the further exercise of that or any other
          right or remedy. Any waiver of any provision of these Terms will be effective only if in
          writing and signed by the relevant party.
        </p>

        <p>
          14.3 Upon termination or expiration of these Terms, any provision which, by its nature or
          express terms should survive, including but not limited to any obligations in relation to
          the liability of, or indemnities (if any) given by, the respective parties, will survive
          such termination or expiration.
        </p>

        <p>
          14.4 If any provision of these Terms is held by a court or tribunal to be invalid, illegal
          or unenforceable and can be deleted without altering the essence of these Terms, it shall
          be deemed deleted without affecting the validity and enforceability of the remaining
          provisions of these Terms. If the invalid, illegal or unenforceable provision cannot be
          deleted without altering the essence of these Terms, we may amend these Terms to remedy
          such invalidity, illegality or unenforceability to the extent needed to achieve the intent
          of the original provision.
        </p>

        <p>
          14.5 We welcome feedback, comments and suggestions for improvements to the Service
          (“Feedback”). You acknowledge and expressly agree that any contribution of Feedback does
          not and will not give or grant you any right, title or interest in the Service or in any
          such Feedback. All Feedback becomes the sole and exclusive property of the Company, and
          the Company may use and disclose Feedback in any manner and for any purpose whatsoever
          without further notice or compensation to you and without retention by you of any
          proprietary or other right or claim. You hereby assign to the Company any and all right,
          title and interest (including, but not limited to, any patent, copyright, trade secret,
          trademark, show-how, know-how, moral rights and any and all other intellectual property
          right) that you may have in and to any and all Feedback.
        </p>

        <p>
          14.6 Each party shall pay its own costs incurred in connection with the performance of any
          of its obligations under these Terms, save to the extent that is expressly provided
          otherwise in these Terms.
        </p>

        <p>
          14.7 No provision in these Terms is intended to create or shall create a partnership
          between the parties or establishes a party as the agent of another party for any purpose.
          A party has no authority to act for, bind, contract in the name of, or create a liability
          for the other party by any means or for any purpose.
        </p>

        <p>
          14.8 Each party shall, and shall use all reasonable endeavors to procure that any
          necessary third party shall, execute and deliver such documents and perform such acts as
          may reasonably be required for the purpose of giving full effect to these Terms.
        </p>

        <div>
          <p>14.9 Notwithstanding any other provision in these Terms:</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              you shall not without our prior written consent, assign, transfer, novate, part with,
              outsource, subcontract or delegate any of your rights, responsibilities and/or
              obligations under these Terms (in whole or in part); and
            </li>
            <li>
              we may assign, transfer, novate, part with or subcontract any of our rights,
              responsibilities and/or obligations under these Terms (in whole or in part) to any
              other affiliate,subsidiary,or successor in interest of the any business associated
              with our Services without your prior consent.
            </li>
          </ol>
        </div>

        <p>
          14.10 A person who is not a party to these Terms has no right to enforce any terms of
          these Terms.
        </p>

        <p>
          14.11These Terms are drafted in the English language. If these Terms are translated into
          any language other than English, the English version shall prevail to the extent of any
          inconsistency, unless otherwise required under applicable laws and regulations.
        </p>
      </div>
    ),
  },
  {
    id: 'contact-information',
    title: '15. CONTACT INFORMATION',
    content: (
      <div className="space-y-4 text-base font-normal text-content-primary">
        <p>
          If you have any complaints, suggestions or other questions on these Terms, please contact
          us through email at <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a> or by
          accessing <a href="https://x.com/CodeFlicker_ai">https://x.com/CodeFlicker_ai</a>.
        </p>
        <p>
          We will review the issues involved as soon as possible and reply to you in a timely manner
          after verifying your identity.
        </p>
      </div>
    ),
  },
];

const TermOfUse: React.FC = () => {
  return (
    <div className="size-full">
      <NavBar />
      <PageWithTOC
        title="Terms of Service"
        subtitle="Release Date: 2025/08/04   Effective Date: 2025/08/04"
        sections={termOfUseSections}
      />
      {/* <Signature className="fixed bottom-[244px] right-[120px]" /> */}
    </div>
  );
};

export default TermOfUse;